const registry = new Map();

export function registerModal(id, instance) {
  if (id) registry.set(id, instance);
}

export function unregisterModal(id) {
  if (id) registry.delete(id);
}

export const bvModalCompat = {
  show(id) {
    const inst = registry.get(id);
    if (inst) inst.show();
    else console.warn(`[bvModalCompat] show: no modal registered with id "${id}"`);
  },
  hide(id) {
    const inst = registry.get(id);
    if (inst) inst.hide();
    else console.warn(`[bvModalCompat] hide: no modal registered with id "${id}"`);
  },
  toggle(id) {
    const inst = registry.get(id);
    if (inst) inst.toggle();
  }
};
